import { CardSkeleton, TableSkeleton } from "@/components/Skeleton";

type Props = {
  includeFilters?: boolean;
};

export default function RosterActivityPageSkeleton({ includeFilters = false }: Props) {
  return (
    <div
      data-testid="roster-activity-page-skeleton"
      role="status"
      aria-busy="true"
      aria-label="Loading roster activity"
    >
      {includeFilters ? <CardSkeleton className="!w-full" width={100} rows={5} /> : null}
      <TableSkeleton columns={5} rows={5} />
    </div>
  );
}
